import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule as FontAwesomeLibraryModule } from '@fortawesome/angular-fontawesome';


/**
 * Wrapper dla @fortawesome/angular-fontawesome
 *
 * @export
 * @class FontAwesomeModule
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FontAwesomeLibraryModule
  ],
  exports: [
    FontAwesomeLibraryModule
  ]
})
export class FontAwesomeModule { }
